import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@honda-canada/design-system-react';

import themeStyles from './AddToBuildButton.styles';

const StyledBuildWrapper = themeStyles.apply(Box, 'BuildWrapper');

const BuildWrapper = ({ isOnBuild, children }) => (
  <StyledBuildWrapper isOnBuild={isOnBuild}>{children}</StyledBuildWrapper>
);

BuildWrapper.propTypes = {
  isOnBuild: PropTypes.bool,
  children: PropTypes.node,
};

export default BuildWrapper;
